export default __webpack_public_path__ + "static/media/hccb1.5729340e.jpg";